import { isDefaultValueQuery } from './defaultIfRule';
import { evaluateConditions } from '../../../condition-engine/evaluateConditions';
import { evaluateQuery } from '../../../condition-engine/queries';
export function evaluateDefaultIfRules(rules, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    const firstConditionToPass = rules.find((rule) => {
        if (rule.conditions === null)
            return true;
        return evaluateConditions(rule.conditions, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride).isValid;
    });
    return firstConditionToPass;
}
export function evaluateDefaultValueParams(defaultValue, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    if (isDefaultValueQuery(defaultValue)) {
        return evaluateQuery(defaultValue.fromQuery, answersResolver, repeatedInstanceIdentifiers, timezone, {}, currentDateOverride);
    }
    return defaultValue;
}
export function getConditionalDefaultValueForField(rules, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    const defaultIfCondition = evaluateDefaultIfRules(rules, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride);
    if (!defaultIfCondition)
        return;
    const defaultFieldValue = evaluateDefaultValueParams(defaultIfCondition.defaultValue, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride);
    return defaultFieldValue;
}
